import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FIRST_RESPONSE_SLA, NEXT_RESPONSE_SLA, CLOSE_TICKET_SLA, RESOLVED_IN_SLA, RESOLVED_OUT_OF_SLA } from 'svh-tickets-lib/tickets/public/constants';
import { getIsSLAResolved, getSLAIconColorTokenFromStatus } from 'svh-tickets-lib/tickets/public/operators';
import SLADetailsTime from './SLADetailsTime';
import { SuccessIcon, TimeIcon } from 'foundations-assets';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLACategoryName = ({
  slaCatagory
}) => {
  switch (slaCatagory) {
    case FIRST_RESPONSE_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.slaTypes.firstReply"
      });
    case CLOSE_TICKET_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.slaTypes.timeToClose"
      });
    case NEXT_RESPONSE_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.slaTypes.nextReply"
      });
    default:
      throw new Error(`SLACatagory ${slaCatagory} isn't one of the known types.`);
  }
};
SLACategoryName.displayName = 'SLACategoryName';
const getSuccessCheck = slaStatus => {
  switch (slaStatus) {
    case RESOLVED_IN_SLA:
      return /*#__PURE__*/_jsx(SuccessIcon, {
        color: "fill-accent-green-default"
      });
    case RESOLVED_OUT_OF_SLA:
      return /*#__PURE__*/_jsx(SuccessIcon, {
        color: "fill-accent-yellow-default"
      });
    default:
      throw new Error(`SLAStatus ${slaStatus} isn't one of the known types.`);
  }
};
const getCompletedMessage = slaStatus => {
  switch (slaStatus) {
    case RESOLVED_IN_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.completed"
      });
    case RESOLVED_OUT_OF_SLA:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.completedLate"
      });
    default:
      throw new Error(`SLAStatus ${slaStatus} isn't one of the known types.`);
  }
};
const SLADetailRow = ({
  slaDetails
}) => {
  const isSLAResolved = getIsSLAResolved(slaDetails.status);
  return /*#__PURE__*/_jsxs(TFlex, {
    justify: "between",
    align: "center",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: 0,
      inlineSize: "17px",
      children: isSLAResolved ? getSuccessCheck(slaDetails.status) : /*#__PURE__*/_jsx(IconHolder, {
        icon: TimeIcon,
        color: getSLAIconColorTokenFromStatus(slaDetails.status)
      })
    }), /*#__PURE__*/_jsx(Box, {
      grow: 1,
      paddingInlineStart: "300",
      paddingInlineEnd: "900",
      children: /*#__PURE__*/_jsx(SLACategoryName, {
        slaCatagory: slaDetails.category
      })
    }), /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: isSLAResolved ? getCompletedMessage(slaDetails.status) : /*#__PURE__*/_jsx(SLADetailsTime, {
        dueDate: slaDetails.dueDate
      })
    })]
  });
};
SLADetailRow.displayName = 'SLADetailRow';
export default SLADetailRow;